/* Design Your Own Tallit — layered preview + live price + cart (line-item properties).
   Placeholder layers now; real photos swap into the same data-file slots later. */
(function () {
  "use strict";
  var root = document.querySelector("[data-dyot]");
  if (!root) return;
  var stage = root.querySelector("[data-dyot-stage]");
  var totalEl = root.querySelector("[data-dyot-total]");
  var summaryEl = root.querySelector("[data-dyot-summary]");

  var size = { vid: null, price: 0, value: "" };

  function money(n) { return "$" + (Math.round(n * 100) / 100).toFixed(2); }
  function setLayer(name, file) {
    var img = stage.querySelector('img[data-layer="' + name + '"]');
    if (img) img.src = file || "";
  }

  // ----- option groups (buttons) -----
  root.querySelectorAll("[data-group]").forEach(function (grp) {
    grp.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        grp.querySelectorAll("button").forEach(function (x) { x.classList.remove("is-selected"); });
        b.classList.add("is-selected");
        if (b.hasAttribute("data-layer")) setLayer(b.getAttribute("data-layer"), b.getAttribute("data-file"));
        if (b.hasAttribute("data-size-vid")) {
          size.vid = b.getAttribute("data-size-vid");
          size.price = parseFloat(b.getAttribute("data-size-price")) || 0;
          size.value = b.getAttribute("data-value");
        }
        recompute();
      });
    });
  });

  // set initial size from the pre-selected button
  var sz0 = root.querySelector('[data-group="Size"] button.is-selected');
  if (sz0) { size.vid = sz0.getAttribute("data-size-vid"); size.price = parseFloat(sz0.getAttribute("data-size-price")) || 0; size.value = sz0.getAttribute("data-value"); }

  // ----- personalization toggles -----
  root.querySelectorAll("[data-toggle]").forEach(function (cb) {
    cb.addEventListener("change", function () {
      var field = root.querySelector('[data-field="' + cb.getAttribute("data-toggle") + '"]');
      if (field) field.hidden = !cb.checked;
      recompute();
    });
  });
  root.querySelectorAll("[data-prop]").forEach(function (inp) { inp.addEventListener("input", recompute); });

  function selections() {
    var rows = [];
    root.querySelectorAll("[data-group]").forEach(function (grp) {
      var sel = grp.querySelector("button.is-selected");
      if (sel) rows.push([grp.getAttribute("data-group"), sel.getAttribute("data-value"), parseFloat(sel.getAttribute("data-price")) || 0]);
    });
    root.querySelectorAll("[data-toggle]").forEach(function (cb) {
      if (cb.checked) {
        var name = cb.getAttribute("data-toggle");
        var price = parseFloat(cb.getAttribute("data-price")) || 0;
        var field = root.querySelector('[data-field="' + name + '"]');
        var txt = field ? field.querySelector("[data-prop]") : null;
        var val = txt && txt.value.trim() ? 'Yes — "' + txt.value.trim() + '"' : "Yes";
        rows.push([name, val, price]);
      }
    });
    return rows;
  }

  function recompute() {
    var rows = selections();
    var total = size.price;
    rows.forEach(function (r) { total += r[2]; });
    if (totalEl) totalEl.textContent = money(total);
    if (summaryEl) {
      var html = '<div><dt>Size</dt><dd>' + (size.value || "—") + "</dd></div>";
      rows.forEach(function (r) {
        if (r[0] === "Size") return;
        html += "<div><dt>" + r[0] + "</dt><dd>" + r[1] + (r[2] ? "  (+" + money(r[2]) + ")" : "") + "</dd></div>";
      });
      summaryEl.innerHTML = html;
    }
  }

  // ----- add to cart -----
  var addBtn = root.querySelector("[data-dyot-add]");
  if (addBtn) addBtn.addEventListener("click", function () {
    if (!size.vid) return;
    var props = {};
    selections().forEach(function (r) { if (r[0] !== "Size") props[r[0]] = r[1]; });
    root.querySelectorAll("[data-prop]").forEach(function (inp) {
      var field = inp.closest("[data-field]");
      if (field && !field.hidden && inp.value.trim()) props[inp.getAttribute("data-prop")] = inp.value.trim();
    });
    addBtn.disabled = true; addBtn.textContent = "Adding…";
    var url = (window.WC && window.WC.routes && window.WC.routes.cartAdd) || "/cart/add.js";
    fetch(url, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(size.vid, 10), quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Could not add to cart"); });
      window.location.href = "/cart";
    }).catch(function (err) {
      alert(err.message); addBtn.disabled = false; addBtn.textContent = "Add to Cart";
    });
  });

  recompute();
})();
